import { createReducer } from '@reduxjs/toolkit';
import { adapter, initialState } from './state';
import { clearAllAction, clearErrorsAction, getOrders } from './actions';
import { ApiResponse } from '../../models';

export const reducer = createReducer(initialState, builder =>
    builder
        .addCase(getOrders.pending, state => {
            return { ...state, isFetching: true };
        })
        .addCase(getOrders.fulfilled, (state, action) => {
            const { results, customerId } = action.payload;
            const { proformas } = results;
            let newState = adapter.getInitialState({ ...state, isFetching: false });

            const existingOrders = adapter.getSelectors().selectAll(state).filter(o => o.customerId === customerId);
            const newIdSet = new Set(proformas.map(o => o.id));
            for (const order of existingOrders) {
                if (!newIdSet.has(order.id)) {
                    newState = adapter.removeOne(newState, order.id);
                }
            }
            newState = adapter.upsertMany(newState, proformas);

            return newState;
        })
        .addCase(getOrders.rejected, (state, action) => {
            const { errorMessage } = action.payload as ApiResponse;
            return { ...state, isFetching: false, errorMessage };
        })
        .addCase(clearAllAction.fulfilled, () => adapter.removeAll({ ...initialState }))
        .addCase(clearErrorsAction.fulfilled, state => ({ ...state, errorMessage: undefined }))
);
